export const defaultCheckStyle = 'appearance-none w-5 h-5 border-solid flex-none';
//# sourceMappingURL=checkboxStyle.js.map